<button
  type="button"
  class="bell-btn"
  [class.is-open]="panelOpen()"
  (click)="panel.toggle($event)"
  aria-haspopup="dialog"
  [attr.aria-expanded]="panelOpen()"
  [attr.aria-label]="'Notifications, ' + unreadCount() + ' unread'"
  data-testid="notification-bell"
>
  <i class="pi pi-bell" aria-hidden="true"></i>
  @if (unreadCount() > 0) {
  <span class="bell-dot" data-testid="notification-dot" aria-hidden="true"></span>
  }
</button>

<p-popover #panel styleClass="slm-notification-popover" (onShow)="onPanelShow()" (onHide)="onPanelHide()">
  <div class="panel" aria-label="Notifications">
    <div class="panel__head">
      <span class="panel__title">Notifications</span>
      <button type="button" class="panel__close" (click)="closePanel()" aria-label="Close notifications">
        <i class="pi pi-times" aria-hidden="true"></i>
      </button>
    </div>

    <div class="panel__tabs" role="tablist" aria-label="Notification lists">
      <button
        type="button"
        role="tab"
        class="panel__tab"
        [class.panel__tab--active]="activeTab() === 'new'"
        [attr.aria-selected]="activeTab() === 'new'"
        (click)="onTabChanged('new')"
        data-testid="notifications-tab-new"
      >
        New
      </button>
      <button
        type="button"
        role="tab"
        class="panel__tab"
        [class.panel__tab--active]="activeTab() === 'archived'"
        [attr.aria-selected]="activeTab() === 'archived'"
        (click)="onTabChanged('archived')"
        data-testid="notifications-tab-archived"
      >
        Archived
      </button>
    </div>

    @if (loadError()) {
    <div class="panel__error" data-testid="notifications-error">
      <i class="pi pi-exclamation-circle" aria-hidden="true"></i>
      <span>Couldn't load notifications.</span>
      <button type="button" class="panel__retry" (click)="retry()" data-testid="notifications-retry">Retry</button>
    </div>
    } @else if (visibleNotifications().length === 0) {
    <div class="panel__empty" data-testid="notifications-empty">
      <i class="pi pi-check-circle" aria-hidden="true"></i>
      <span>{{ activeTab() === 'new' ? "You're all caught up." : 'No archived notifications.' }}</span>
    </div>
    } @else {
    <ul class="panel__list">
      @for (n of visibleNotifications(); track n.id) {
      <li class="card" [attr.data-testid]="'notification-card-' + n.id">
        <button type="button" class="card__main" (click)="onCardClicked(n)">
          <span class="card__top">
            <span class="card__time">{{ publishedLabel(n.createdDate) }}</span>
            @if (!n.read && activeTab() === 'new') {
            <span class="card__dot" aria-label="Unread" [attr.data-testid]="'notification-unread-' + n.id"></span>
            }
          </span>

          <span class="card__title">{{ n.title }}</span>

          @if (n.badgeText) {
          <span class="card__meta">
            <span [class]="badgeClass(n)">
              <i class="pi pi-clock" aria-hidden="true"></i>
              {{ n.badgeText }}
            </span>
          </span>
          } @if (n.description) {
          <span
            class="card__desc"
            [class.card__desc--expanded]="isExpanded(n.id)"
            appOverflowClamp
            (overflowChange)="setOverflowing(n.id, $event)"
            >{{ n.description }}</span
          >
          }
        </button>

        @if (n.description && showToggle(n.id)) {
        <button
          type="button"
          class="card__readmore"
          (click)="toggleExpanded(n.id)"
          [attr.aria-expanded]="isExpanded(n.id)"
          [attr.data-testid]="'notification-readmore-' + n.id"
        >
          <span>{{ isExpanded(n.id) ? 'Show less' : 'Read more' }}</span>
          <i
            class="pi"
            [class.pi-chevron-down]="!isExpanded(n.id)"
            [class.pi-chevron-up]="isExpanded(n.id)"
            aria-hidden="true"
          ></i>
        </button>
        }

        <div class="card__actions">
          @if (activeTab() === 'new') {
          <button
            type="button"
            class="card__link"
            (click)="onArchive(n, $event)"
            [attr.data-testid]="'notification-archive-' + (n.actionId ?? n.id)"
          >
            Archive
          </button>
          } @else {
          <button
            type="button"
            class="card__link"
            (click)="onUnarchive(n, $event)"
            [attr.data-testid]="'notification-unarchive-' + (n.actionId ?? n.id)"
          >
            Unarchive
          </button>
          } @if (actionLabel(n); as label) {
          <button
            type="button"
            class="card__link card__link--primary"
            (click)="onAction(n, $event)"
            [attr.data-testid]="'notification-action-' + (n.actionId ?? n.id)"
          >
            {{ label }}
          </button>
          }
        </div>
      </li>
      }
    </ul>
    }
  </div>
</p-popover>
